export class PlannedMaintenanceServiceDto {
    plannedMaintenanceServiceId: number;
    serviceId: number;
    serviceName: string;
    cost: number;
    discount: number;
    plannedMaintenanceId: number;
    agreementId: number;

    count: number;
}